import PropTypes from 'prop-types';
import React from 'react';

import * as D from '../../../deps';

const ArtistEvents = props => {
  const { pandoraId } = props;

  return (
    <D.ContentSection isArtistEvents={true} isFirstSection={props.isFirstSection}>
      <D.ArtistEvents artistPandoraId={pandoraId} />
    </D.ContentSection>
  );
};

ArtistEvents.propTypes = {
  pandoraId: PropTypes.string,
  isFirstSection: PropTypes.bool,
};

export default ArtistEvents;
